import { render, staticRenderFns } from "./header_badges.vue.js?vue&type=template&id=00eb1aa6&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header_badges.vue?vue&type=template&id=00eb1aa6&vue3"
import script from "./header_badges.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header_badges.vue?vue&type=script&lang=js&vue3"
export * from "./header_badges.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header_badges.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports